import React from 'react';
import { useLocation } from 'react-router-dom';
import { tiktokOAuthAPI } from '../../components/LoginWithTiktokButton/ApiService';

export default function TikTokOAuth() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    tiktokOAuthAPI(params.get('state') ?? '', params.get('code') ?? '', params.get('scope') ?? '')
    return (
        <></>
    )
}